import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import DetailPatientRow from './DetailPatientRow';

type DetailPatientType = {
  patient: any;
};

const DetailPatient: React.FC<DetailPatientType> = (props) => {
  return (
    <TableContainer
      component={Paper}
      sx={{
        boxShadow: 'none',
        width: '100%',
        height: '100%',
      }}
    >
      <Table
        sx={{
          minWidth: 470,
          '& .MuiTableCell-root.MuiTableCell-head': {
            borderBottom: '1px solid #F3F3F3',
            fontWeight: 700,
            p: '6px 16px',
            fontSize: '14px',
          },
          '& .MuiTableCell-root.MuiTableCell-body': {
            color: 'primary.dark',
            fontSize: '14px',
            py: '6px',
          },
        }}
        aria-label='simple table'
      >
        <TableBody sx={{ '&.MuiTableBody-root th': { fontWeight: 700 } }}>
          <DetailPatientRow
            title='患者名'
            content={props.patient ? props.patient.fullname : ''}
          />
          <DetailPatientRow
            title='患者番号'
            content={props.patient ? props.patient.patientno : ''}
          />
          <DetailPatientRow
            title='共通ID'
            content={props.patient ? props.patient.commonid : ''}
          />
          <DetailPatientRow
            title='サロン番号'
            content={props.patient ? props.patient.salon_no : ''}
          />
          <DetailPatientRow
            title='名前'
            content={props.patient ? props.patient.kana : ''}
          />
          <DetailPatientRow
            title='性別'
            content={props.patient ? props.patient.gendertext : ''}
          />
          <DetailPatientRow
            title='生年月日'
            content={props.patient ? props.patient.dob : ''}
          />
          <DetailPatientRow
            title='年齢'
            content={props.patient ? props.patient.age : ''}
          />
          <DetailPatientRow
            title='電話番号1'
            content={props.patient ? props.patient.phone1 : ''}
          />
          <DetailPatientRow
            title='電話番号2'
            content={props.patient ? props.patient.phone2 : ''}
          />
          <DetailPatientRow
            title='メールアドレス'
            content={props.patient ? props.patient.email : ''}
          />
          <DetailPatientRow
            title='郵便番号'
            content={props.patient ? props.patient.postcode : ''}
          />
          <DetailPatientRow
            title='住所'
            content={props.patient ? props.patient.address : ''}
          />
          <DetailPatientRow
            title='備考'
            content={props.patient ? props.patient.note : ''}
          />
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default DetailPatient;
